// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonIcon_button__21xoo","hasLink":"ButtonIcon_hasLink__FLJF6","disabled":"ButtonIcon_disabled__GadaB"};